export const querySizeMappings = {
	sm: 640,
	md: 768,
	lg: 1024,
	xl: 1280,
	"2xl": 1536,
	"2k": 2048,
} satisfies Record<string, number>;
